import { useShopProvider } from '#provider/useShopProvider.js';
import { RouteWithHeaderBackButton } from 'core';
import { Route, Routes } from 'react-router-dom';
import { ConditionalWrapper } from 'ui';

import { CheckoutPage } from '../pages/Checkout/Checkout';
import { MyStoresPage } from '../pages/Stores/MyStores/MyStores';
import Store from '../pages/Stores/Store/Store';
import StoreItem from '../pages/Stores/StoreItem/StoreItem';
import { StoreCauseGuard } from './StoreCauseGuard';

/**
 * Routes for a specific store
 */
const StoreRoutes = () => {
  const { storeFrontOptions } = useShopProvider();
  const { disableStorePageBackButton = false } = storeFrontOptions ?? {};

  return (
    <Routes>
      <Route element={<StoreCauseGuard />}>
        <Route
          path="items/:itemId"
          element={
            <RouteWithHeaderBackButton>
              <StoreItem />
            </RouteWithHeaderBackButton>
          }
        />

        <Route path="*" element={<Store />} />
        <Route
          index
          element={
            <ConditionalWrapper
              condition={!disableStorePageBackButton}
              wrapper={(children) => (
                <RouteWithHeaderBackButton routeTo="../../my-stores">
                  {children}
                </RouteWithHeaderBackButton>
              )}
            >
              <Store />
            </ConditionalWrapper>
          }
        />
      </Route>
    </Routes>
  );
};

/**
 * Routes for all stores
 */
const StoresRoutes = () => {
  return (
    <Routes>
      <Route path="my-stores" element={<MyStoresPage />} />

      <Route path=":storeId/*" element={<StoreRoutes />} />

      <Route index element={<StoreRoutes />} />
      <Route path="*" element={<CheckoutPage />} />
    </Routes>
  );
};

export { StoreRoutes, StoresRoutes };
